import { render, staticRenderFns } from "./BrokerLeadKanbanView.vue?vue&type=template&id=4b2a2680"
import script from "./BrokerLeadKanbanView.vue?vue&type=script&lang=js"
export * from "./BrokerLeadKanbanView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports